/**
 * Theme-aware CSS variable maps for NativeWind 4.
 *
 * Why these live in JS rather than only in `apps/mobile/global.css`:
 *
 * The CSS variable definitions in `:root` / `.dark` inside `global.css`
 * work fine on web — the browser cascade swaps the variables when
 * `documentElement.classList.add('dark')` fires. On native iOS / Android,
 * NativeWind 4's runtime does NOT add an equivalent class to the React
 * tree; it tracks the colour-scheme flag via `useColorScheme()` for
 * utility variants (`dark:bg-paper-up`) but it does not re-evaluate the
 * `.dark` CSS selector's variable bindings. Result: tokens like
 * `bg-canvas` always resolved to the `:root` (light) value on native,
 * regardless of theme — the "everything in light mode" bug the user
 * reported on the iOS native build twice.
 *
 * Fix: use NativeWind's `vars()` to apply the variable bindings as an
 * inline style on a wrapping View. NativeWind handles the CSS-variable
 * scoping the same way on both web and native, so every child of that
 * wrapper resolves `rgb(var(--color-canvas))` against the active map.
 *
 * `global.css` keeps the same `:root` / `.dark` declarations as the
 * web fallback (and so the values are visible in a single place for
 * a human reviewer); the wrapper-vars override them at runtime when
 * the values diverge.
 */

import { vars } from 'nativewind'

export const themeVarsLight = vars({
  '--color-canvas': '236 225 194',
  '--color-paper': '244 236 211',
  '--color-paper-up': '232 226 200',
  '--color-ink': '24 23 15',
  '--color-ink-soft': '107 91 62',
  '--color-olive': '74 90 42',
  '--color-olive-up': '107 126 62',
  '--color-brass': '184 137 58',
  '--color-blood': '160 24 24',
})

export const themeVarsDark = vars({
  '--color-canvas': '26 31 18',
  '--color-paper': '44 53 32',
  '--color-paper-up': '35 42 24',
  '--color-ink': '230 225 196',
  '--color-ink-soft': '138 140 110',
  '--color-olive': '138 161 74',
  '--color-olive-up': '179 204 102',
  '--color-brass': '217 168 90',
  '--color-blood': '224 70 63',
})
